export default __webpack_public_path__ + "static/media/plug.73533bd8.png";